import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { useReactToPrint } from 'react-to-print';
import { pageTitle } from '../../../../store/softSlice';
import { PdfExportBtn } from '../../../../widgets/AppBtn';
import { fetchDataFromApi } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { ToastWarning } from '../../../../widgets/ToastMessage';
import PartimeSalayFullTimeSalaryListView from '../../../../components/hr/report/part_full_salary/PartimeSalayFullTimeSalaryListView';
import PartimeSalayFullTimeSalarySearchView from '../../../../components/hr/report/part_full_salary/PartimeSalayFullTimeSalarySearchView';
import PrintPartTimeSalaryView from '../../../../components/hr/report/part_full_salary/PrintPartTimeSalaryView';

const PartimeSalayFullTimeSalaryReportListView = ({ PageTitle, setIconsButton }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(pageTitle({ "title": PageTitle }));
        setIconsButton(<PdfExportBtn onClick={handlePrintCard} />);
        document.title = `${PageTitle}`;
    }, []);
    const [PayrollList, setOnPayRollList] = useState([]);
    const PayrollListView = async (monthh, yearr) => {
        try {
            if (!monthh) {
                ToastWarning("Select month name");
            } else if (!yearr) {
                ToastWarning("Enter year name");
            } else {
                await fetchDataFromApi(AppURL.HR_URL + `hr-employee-payroll-list-view/?monthh=${monthh}&&yearr=${yearr}`).then((res) => {
                    setOnPayRollList(res);
                });
            }

        } catch (error) {
            console.log(error);
        }
    }


    const componentListRef = useRef();
    const RenderListComponent = React.forwardRef(() => (
        <PrintPartTimeSalaryView PayrollList={PayrollList} />
    ));

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current, // Reference the component for printing
    });
    return (
        <Fragment>
            <Grid container spacing={0.5}>
                <Grid item lg={12} sm={12} xs={12} md={12} xl={12}>
                    <PartimeSalayFullTimeSalarySearchView PayrollListView={PayrollListView} />
                </Grid>
                <Grid item lg={12} sm={12} xs={12} md={12} xl={12}>
                    <PartimeSalayFullTimeSalaryListView PayrollList={PayrollList} />
                </Grid>
            </Grid>
            <div className='hidden'>
                <div ref={componentListRef}>
                    <RenderListComponent />
                </div>
            </div>
        </Fragment>
    )
}

export default PartimeSalayFullTimeSalaryReportListView